import User from '../models/user';
import useUser from './useUser';
import Administrator from '../models/administrator';

const useClientUser = () => {
  const { fetchUser } = useUser();

  /**
   * @function fetchUsersDetails fetch user data for each user in Client.assignedUsers array
   */
  const fetchUsersDetails = (assignedUsers: (User | Administrator)[]): Promise<User[]> => {
    const promises = [];
    assignedUsers.forEach(user => {
      promises.push(fetchUser(user.id));
    });
    return Promise.all(promises);
  };

  /**
   * @function userSort sort the array of users by a given property. If property values are boolean, first sort by name.
   * @param users array of User objects to sort
   * @param property User property to sort on
   * @param direction sort direction: 'asc' or 'desc'
   */
  const userSort = (users: User[], property: string, direction: 'asc' | 'desc'): User[] => {
    if (typeof users[0][property] == 'string') {
      return users.sort((a, b) => {
        if (a[property].toUpperCase() < b[property].toUpperCase()) {
          if (direction == 'asc') {
            return -1;
          } else if (direction == 'desc') {
            return 1;
          }
        }
        if (a[property].toUpperCase() > b[property].toUpperCase()) {
          if (direction == 'asc') {
            return 1;
          } else if (direction == 'desc') {
            return -1;
          }
        }
        return 0;
      });
    } else if (typeof users[0][property] == 'boolean') {
      const nameSorted = userSort(users, 'lastName', 'asc');
      if (direction == 'asc') {
        return nameSorted.sort((a, b) => Number(a.status) - Number(b.status));
      }
      if (direction == 'desc') {
        return nameSorted.sort((a, b) => Number(b.status) - Number(a.status));
      }
    }
  };
  return {
    userSort,
    fetchUsersDetails
  };
};

export default useClientUser;
